export default __webpack_public_path__ + "static/pragicts-ai-decision-making-6e64067a1b5c16c5a85ed9331d7e0bd3.jpg";